<template>
    <v-alert
        v-if="content"
        type="info"
        prominent
        outlined
        border="left"
        class="dashboard-message"
    >
        <markdown-viewer :key="content" :value="content" />
    </v-alert>
</template>

<script>
import api from '@/api'

export default {
    name: 'DashboardMessageWidget',
    props: {
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { content: null }
    },
    watch: {
        refreshKey: { handler: 'fetchData', immediate: true },
    },
    methods: {
        async fetchData() {
            try {
                const data = await api.get('systemPages/GetByName', { name: 'DashboardMessage' }, { silent: true })
                this.content = data && String(data).trim() ? data : null
            } catch (err) {
                // No DashboardMessage page, not approved, or fetch failed — silently hide.
                this.content = null
            }
        },
    },
}
</script>

<style scoped>
.dashboard-message { margin-bottom: 12px; }
.dashboard-message >>> .toastui-editor-contents { background: transparent; }
</style>
